import BaseModalForm from "./BaseModalForm";

export default class PhoneLoginModal extends BaseModalForm {
    get modalElement() {
        return document.querySelector('.modal#phoneCodeLogin')
    }

    get formElement() {
        return document.querySelector('.modal#phoneCodeLogin form')
    }

    get resendCodeButton() {
        return document.querySelector('.modal#phoneCodeLogin .resend-code-button')
    }

    get resendCodeTimerElement() {
        return document.querySelector('.modal#phoneCodeLogin .resend-code-button span.timer')
    }

    hideResendCodeButton() {
        this.resendCodeButton.style.display = 'none'
        return this
    }

    showResendCodeButton() {
        this.resendCodeButton.style.display = ''
        return this
    }

    set phone(phone) {
        this.formElement.phone.value = phone
    }

    get phone() {
        return this.formElement.phone.value
    }

    disableCodeInput() {
        this.formElement.code.setAttribute('disabled', 'disabled')
        this.formElement.code.setAttribute('hidden', 'hidden')
        return this
    }

    enableCodeInput() {
        this.formElement.code.removeAttribute('disabled')
        this.formElement.code.removeAttribute('hidden')
        return this
    }

    init() {
        super.init()
        this.hideResendCodeButton()
    }

    run(onSubmit, resendCode, open = true) {
        $(this.formElement).off('submit')
        $(this.resendCodeButton).off('click')

        open && this.open()
        $(this.formElement).on('submit', event => {
            event.preventDefault()
            onSubmit(() => this.reset())
            return false
        })

        $(this.resendCodeButton).on('click', event => {
            event.preventDefault()
            resendCode && resendCode()
            return false
        })
    }


    reset() {
        this.disableCodeInput()
        super.reset()
    }
}
